import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourDashboardApi from '@/features/dashboard/tours/api/tourDashboardApi.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { TourDashboardSalesDto } from '@/features/dashboard/tours/types/dashboard/dto/TourDashboardSalesDto.ts';

const useGetTourDashboardSales = (tourId: string) =>
  useQuery(getTourDashboardSalesQueryOptions(tourId));

export const getTourDashboardSalesQueryOptions = (
  tourId: string,
): UseQueryOptions<TourDashboardSalesDto> => ({
  queryKey: tourDashboardApiQueryKeys.sales(tourId),
  queryFn: () => tourDashboardApi.getSales(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60,
});

export default useGetTourDashboardSales;
